import '../Tutorial.css';
import React from 'react';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T110ClickDeck() {

    /*
  useEffect(() => {
    UserService.sendEvent('ClickDeck110');
  }, []);
     */

    const text = 'Close the window.';

    return (
        <div>

            <div className={'T90Left'}></div>
            <div className={'T90Bottom'}></div>


            <TutorialGirl position={'Left'} undressingProcess={3} />
            <div className='tutorialContainer tutorialBottomContainer'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>
        </div>

    );
}

export default T110ClickDeck;
